import React from "react";
import PropTypes from "prop-types";
import Icon from "../../Common/Icon";

const Submit = (props) => {
  const {
    form,
    formik: { isSubmitting = false },
    config: { label = "Submit", class: className = "", disabled },
  } = props;

  return (
    <button
      type="button"
      className={`btn ${className} 
      ${disabled ? "btn--disabled" : ""}
      ${isSubmitting ? "btn--disabled btn--loading" : ""}`}
      disabled={disabled || isSubmitting}
      onClick={(e) => form.handleSubmitButtonClick(e)}
    >
      {label}
      <Icon className="btn__icon btn__icon--right" iconName="arrow-right" />
      <Icon className="btn__icon btn__icon--loading" iconName="loading-dark" />
    </button>
  );
};

Submit.propTypes = {
  config: PropTypes.object.isRequired,
};

export default Submit;



// WEBPACK FOOTER //
// ./src/components/FormTemplates/Content/Submit.js